
export const jobInformationValidation = (values) => {
    const errors = {}
    
    if (!values.number_of_positions) {
      errors.number_of_positions = "Number of position is required."
    }
    if(!values.type) {
      errors.type = "Reason for replacement is required."
    }
    if(!values.employee_name) {
      errors.employee_name = "Employee name is required."
    }
    if (!values.target_date) {
        errors.target_date = "Select Target date."
    }
    
    return errors
}
  

export const positionInformationValidation = (values) => {
  const errors = {}

  if(!values.position_title){
    errors.position_title = "Position title is required"
  }

  if(!values.designation){
    errors.designation = "Designation is required"
  }

  if(!values.contract){
    errors.contract = "Contract is required"
  }

  // if(!values.confidential){
  //   errors.confidential = "Co is required"
  // }

  if(!values.min_salary){
    errors.min_salary = "Minimum salary is required"
  }

  if(!values.max_salary){
    errors.max_salary = "Maximum salary is required"
  }

  if(!values.currency_type){
    errors.currency_type = "Currency type is required"
  }

  if(!values.entity){
    errors.entity = "Entity is required"
  }

  if(!values.department){
    errors.department = "Department is required"
  }

  if(!values.hiring_manager_email){
    errors.hiring_manager_email=" Hiring Manager Email is required"
  }else if(!/^.+@.+$/i.test(values.hiring_manager_email)){
    errors.hiring_manager_email="Invalid email address"
  }

  if(!values.department_head_email){
    errors.department_head_email="Department Head Email is required"
  }else if(!/^.+@.+$/i.test(values.department_head_email)){
    errors.department_head_email="Invalid email address"
  }

  if(!values.location){
    errors.location = "Location is required"
  }

  return errors
}

export const sourcingAndSelectionValidation = (values) => {
  const errors = {}
  if(!values.international){
    errors.international = "Choose adversitment."
  }
  if(!values.process){
    errors.process = "Choose recrument process."
  }
  if(!values.source){
    errors.source = "Choose one."
  }
  if(!values.length){
    errors.length = "Length of Advertistment is required."
  }
  if(!values.length){
    errors.length = "Length of Advertistment is required."
  }

  // if(!values.channel_1 && !values.channel_2){
  //   errors.channel_1 = "Choose advertisting channel."
  // }
  return errors
}

export const interviewerValidation = (values) => {

  const errors = []
  
  if(!values.interviewer1) {
    errors.interviewer1 = "Interviewer Name is Required"
  }

  return errors

}